export const PRODUCT_TYPES_REDUCER_NAME = 'product-types';

export const productTypesReducer = (state = {}) => state;

export const getProductTypes = (state) => state[PRODUCT_TYPES_REDUCER_NAME];
